import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props} viewBox='150 50 400 450'>
    <path d='m490 350h-280v-35c0-32.336 43.902-59.469 103.48-67.512 2.707-5.0195 4.2578-10.637 4.2578-16.566 0-5.3398-1.582-10.324-3.8594-15.027-20.23-13.809-33.883-38.582-33.883-67.145 0-43.492 31.34-78.75 70-78.75s70 35.258 70 78.75c0 28.562-13.648 53.336-33.883 67.145-2.2734 4.7031-3.8594 9.6875-3.8594 15.027 0 5.9297 1.5508 11.547 4.2578 16.566 59.582 8.043 103.48 35.176 103.48 67.512zm-93.332 46.668h-93.332v93.332h93.332zm-140 0h-93.336v93.332h93.332zm280 0h-93.332v93.332h93.332z' />
  </Base>
)
